import { Card, Flex, theme } from 'antd';
import { FC } from 'react';
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { AppCardList, DomainPunycode } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';
import { CommonContainerTitle } from '@/common/layouts';

import { useGetAllRobotsQuery } from '@/modules/Domains';

interface Props {
  siteId: string;
  currentPage: number;
  siteDomainsItems: BaseQueryParams<typeof useGetAllRobotsQuery>['data']['items'];
  siteDomainsTotalItems: BaseQueryParams<typeof useGetAllRobotsQuery>['data']['meta']['totalItems'];
  siteDomainsItemsPerPage: BaseQueryParams<typeof useGetAllRobotsQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
  handleBack: () => void;
}

export const RobotsDomainsListView: FC<Props> = ({
  siteId,
  currentPage,
  siteDomainsItems,
  siteDomainsTotalItems,
  siteDomainsItemsPerPage,
  isLoading,
  handleChangePage,
  handleBack
}) => {
  const { token } = theme.useToken();
  const domainId = useParams()['*'];

  return (
    <>
      <CommonContainerTitle onBack={ handleBack }>Вийнятки для роботів</CommonContainerTitle>

      <Card>
        <AppCardList
          headerTitle={ null }
          pagination={{
            current: currentPage,
            total: siteDomainsTotalItems,
            pageSize: siteDomainsItemsPerPage,
            disabled: isLoading,
            onChange: (page: number) => handleChangePage(page)
          }}
          selectedKey={ domainId }
          rowKey="id"
          titleKey="name"
          grid={{
            gutter: 16,
            xs: 1,
            sm: 1,
            md: 1,
            lg: 2,
            xl: 2,
            xxl: 2
          }}
          navigateTo={ ({ id }) => ({ to: AppRoutes.RobotsById.replace(':siteId', siteId).replace(':domainId', id) }) }
          list={ siteDomainsItems }
          titleRender={ (title) => <DomainPunycode domainName={ title }/> }
          content={ (record) => <Flex align="center">
            <span style={{ fontFamily: 'monospace' }}>robots.txt:</span>&nbsp;
            {
              record.isRobots
                ? <CheckCircleFill color={ token.colorSuccess }/>
                : <XCircleFill color={ token.colorWarning }/>
            }
          </Flex> }
        />
      </Card>
    </>
  );
};
